import React, { useState } from 'react';
import { Form, Button } from 'antd';
import GatewaySelect from '../common/GatewaySelect';
import { Modal } from 'antd';
import { updateProjectGateway } from '../../api/project';
import { cloneDeep } from 'lodash';
import { ArrowRightOutlined } from '@ant-design/icons';
type Update = { newMac: string, originMac: string };
interface UpdatorProps {
    value: Update,
    onChange: (v: Update) => void
}
const UpdateGateway = ({ value, onChange }: UpdatorProps) => {
    return (
        <div style={{ display: 'flex', gap: 20 }}>
            <GatewaySelect plain value={value.originMac} />
            <ArrowRightOutlined/>
            <GatewaySelect value={value.newMac} onChange={newMac => {
                onChange({
                    ...value,
                    newMac
                })
            }} />
        </div>
    )
}

const BatchUpdateGateway = ({ value, onChange }:
    { value?: Update[], onChange?: (value: Update[]) => void }) => {
    return (
        <div>
            {
                value?.map((update, index) => {
                    return <UpdateGateway value={update} onChange={(updated) => {
                        const copy = cloneDeep(value);
                        copy[index] = updated;
                        onChange?.(copy);
                    }} />
                })
            }

        </div>
    )
}

const UpdateProjectGateway: React.FC<{
    project?: Project,
    open?: boolean,
    onDone?: () => void,
    onCancel?: () => void,
}> = ({ project, open, onDone, onCancel }) => {
    const [loading, setLoading] = useState(false);
    return (
        <Modal
            destroyOnClose
            footer={null}
            onCancel={onCancel}
            open={open}
            title='更改网关'
        >
            <Form
                labelCol={{ span: 6 }}
                wrapperCol={{ span: 16 }}
                style={{ maxWidth: 600 }}
                initialValues={{
                    gateways: project?.gateways?.map(i => {
                        return {
                            newMac: i.mac,
                            originMac: i.mac,
                        }
                    })
                }}
                autoComplete="off"
                onFinish={values => {
                    setLoading(true)
                    updateProjectGateway({
                        "requests": values.gateways,
                        "projectId": project?.projectId
                    })
                        .then(success => {
                            if (success) {
                                onDone?.()
                            }
                        })
                        .finally(() => setLoading(false))
                }}
            >
                <Form.Item<ProjectFormValue>
                    name="gateways"
                    rules={[{ required: true }]}
                >
                    <BatchUpdateGateway />
                </Form.Item>
                <Form.Item>
                    <div
                        style={{
                            display: 'flex', justifyContent: 'end', gap: 20, width: '100%'
                        }}
                    >
                        <Button onClick={onCancel}>取消</Button>
                        <Button loading={loading} htmlType='submit' type='primary'>确定</Button>
                    </div>

                </Form.Item>
            </Form>
        </Modal>
    );
}

export default UpdateProjectGateway;